module.exports = __webpack_public_path__ + "static/media/12_shape_l.dced324f.webp";